export default "__VITE_ASSET__d3fa2516__"